import React from 'react'
import cn from 'classnames'
import { useTranslation } from 'lib/i18n'

import Heading from 'components/Heading/Heading'
import SearchInput from 'components/NavigationBar/SearchInput'
import Wrapper from 'components/Wrapper/Wrapper'
import useStickiness from 'hooks/useStickiness'

import styles from './SearchHeader.module.css'

const SearchHeader = () => {
  const { t } = useTranslation()
  const { isSticky, stickyRef } = useStickiness()

  return (
    <>
      <div className={cn(styles.backbone, { [styles.visible]: isSticky })} />

      <div
        ref={stickyRef}
        className={cn(styles.wrapper, { [styles.sticky]: isSticky })}
      >
        <Wrapper>
          <div className={styles.title}>
            <Heading level="h2" color="dark">
              <h1>{t('SearchHeader.title', 'Search')}</h1>
            </Heading>
          </div>
          <SearchInput />
        </Wrapper>
      </div>
    </>
  )
}

export default SearchHeader
